var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.516,
    height: 23.274,
    viewBox: "0 0 20.516 23.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(-30.75 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M49.015,2.669h-.667V2a2,2,0,0,0-2-2H33a2,2,0,0,0-2,2V18.1a2,2,0,0,0,2,2h.667v.667a2,2,0,0,0,2,2H49.015a2,2,0,0,0,2-2V4.67A2,2,0,0,0,49.015,2.669ZM34.255,5.142a1.988,1.988,0,0,0-.586,1.415V18.771H33a.668.668,0,0,1-.667-.667V2A.668.668,0,0,1,33,1.334H46.346A.668.668,0,0,1,47.013,2v.667H37.558a1.988,1.988,0,0,0-1.415.586ZM37.672,4V6.672H35V6.558a.663.663,0,0,1,.2-.472L37.086,4.2a.663.663,0,0,1,.472-.2Zm12.01,16.769a.668.668,0,0,1-.667.667H35.67A.668.668,0,0,1,35,20.772V8.006h3.336a.667.667,0,0,0,.667-.667V4H49.015a.668.668,0,0,1,.667.667Z",
    transform: "translate(-31 0)",
    fill: "#333",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(36.338 9.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M162.343,212H151.667a.667.667,0,1,0,0,1.334h10.675a.667.667,0,1,0,0-1.334Z",
    transform: "translate(-151 -212)",
    fill: "#333",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(36.338 12.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M162.343,272H151.667a.667.667,0,1,0,0,1.334h10.675a.667.667,0,1,0,0-1.334Z",
    transform: "translate(-151 -272)",
    fill: "#333",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(36.338 14.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M162.343,332H151.667a.667.667,0,0,0,0,1.334h10.675a.667.667,0,0,0,0-1.334Z",
    transform: "translate(-151 -332)",
    fill: "#333",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(36.338 17.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M162.343,392H151.667a.667.667,0,0,0,0,1.334h10.675a.667.667,0,1,0,0-1.334Z",
    transform: "translate(-151 -392)",
    fill: "#333",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilee);
export default __webpack_public_path__ + "static/media/filee.2c31c894bcca64b103f76a1fad09fca0.svg";
export { ForwardRef as ReactComponent };